module.exports = __webpack_public_path__ + "static/media/better-job-fit-patricia.da9be0c9.jpg";